import { toRef } from "vue";
import { provideHttpUIEffect } from "~/lib/httpUIEffect/index";
import initCommonModalFeature, {
  modalProps as commonModalProps,
  modalEmits as commonModalEmits,
} from "~/composables/common-modal";
import { getPreventEventEmitObj } from "~/utils/miscellaneous";
import { ServiceConfig, DataloaderConfig } from "~/utils/service-calls";

export const modalProps = {
  ...commonModalProps,
  modelValue: {},
};

export const modalEmits = {
  ...commonModalEmits,
};

export default function initModalFeature(
  { props, emit, onSubmitConfig },
  { serviceConfigArgs, dataloaderConfigArgs, serviceMethodInitArgs } = {}
) {
  const { dialog } = initCommonModalFeature();
  const modelValueRef = toRef(props, "modelValue");

  serviceConfigArgs = serviceConfigArgs || [modelValueRef];
  dataloaderConfigArgs = dataloaderConfigArgs || [modelValueRef];
  serviceMethodInitArgs = serviceMethodInitArgs || [modelValueRef];

  const {
    graphql,
    dataloader,
    isLoading,
    serviceConfirmationData,
    hasError,
  } = provideHttpUIEffect();

  let {
    serviceConfig,
    dataloaderConfig,
    serviceMethod,
    onSubmitService,
    emitEventName,
    emitEventData,
  } = onSubmitConfig;

  const serviceConfigInstance =
    serviceConfig && new ServiceConfig(serviceConfig, serviceConfigArgs);
  const dataloaderConfigInstance =
    dataloaderConfig &&
    new DataloaderConfig(dataloaderConfig, dataloaderConfigArgs);
  serviceMethod =
    typeof serviceMethod == "function"
      ? {
          init: null,
          callService: serviceMethod,
        }
      : serviceMethod;

  serviceMethod?.init?.(...serviceMethodInitArgs);

  async function submitClicked() {
    const eventEmitObj = getPreventEventEmitObj();

    let curEmitEventName =
      typeof emitEventName == "function" ? emitEventName() : emitEventName;
    let successData, error;

    await (serviceConfigInstance
      ? serviceConfigInstance.callService(graphql)
      : dataloaderConfigInstance
      ? dataloaderConfigInstance.callService(dataloader)
      : serviceMethod?.callService(graphql, dataloader)
    )
      .then((data) => (successData = data))
      .catch((err) => {
        console.error(err);
        error = err;
      });

    const defaultEmitEventData = { successData, error, serviceConfirmationData, hasError };

    onSubmitService &&
      onSubmitService(defaultEmitEventData, eventEmitObj.consumerMethodArgsObj);

    if (eventEmitObj.isEventEmitPrevented()) return;

    emit(
      curEmitEventName,
      emitEventData ? emitEventData(defaultEmitEventData) : defaultEmitEventData
    );

    dialog.value.emitDismiss({
      submitClickSuccess: !hasError.value,
    });
  }

  return {
    dialog,
    graphql,
    dataloader,
    isLoading,
    serviceConfirmationData,
    hasError,
    submitClicked,
  };
}
